import { useEffect, useState } from 'react';
import { useFormConfigurationMapper } from 'domain/shared/oneStop';
import { useFieldHelper } from 'framework/ui/field';
import { FormRowType } from 'framework/form';
import { FormBuilder, type FormInputs } from '../../../core/FormBuilder';
import { Loading } from 'framework/ui/mui-builder';
import { Box, Typography } from '@mui/material';
import { DocumentStorageConfigFields } from 'framework/documentStorage';

const DocumentTemplateForm = () => {
  const { getValue } = useFieldHelper<Nullable<DocumentStorageConfigFields>>({ source: 'fields' });
  const { getValue: getSourceTemplatePath } = useFieldHelper<Nullable<string>>({ source: 'sourceTemplatePath' });
  const [isLoading, setLoading] = useState<Boolean>(true);
  const [formConfiguration, setFormConfiguration] = useState<Nullable<FormInputs>>(null);
  const { getFormConfiguration } = useFormConfigurationMapper();

  const fields = getValue();
  const sourceTemplatePath = getSourceTemplatePath();

  const fileName = sourceTemplatePath?.split('/')?.pop() || 'Document';

  useEffect(() => {
    if (fields) {
      Promise.all([
        getFormConfiguration({ fields } as any, FormRowType.BIG, undefined, {
          isAutoWidth: true,
        }).then(data => setFormConfiguration(data)),
      ])
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fields]);

  if (isLoading || !formConfiguration) {
    return <Loading />;
  }

  return (
    <Box>
      <Typography variant="h4" color="primary" mb={1.25}>
        {fileName}
      </Typography>
      <FormBuilder formInputs={formConfiguration} />
    </Box>
  );
};

export default DocumentTemplateForm;
